import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import React, {useEffect, useRef, useState} from "react";
import {Form, Formik} from "formik";
import {MyTextInput} from "../../Buyer/CustomFormInputs";
import Input from "@material-ui/core/Input";
import NumberInput from "../../../components/NumberInput";
// import ProductEditModal from "./ProductEditModal";
import {ProductsList} from "./ProductCards/ProductsList";
import {fetchCategories, patchOrderSummary, getOrderInfo, cancelOrder, fetchTenantPaymentSettings} from "./ordersCrud";
import { getPaymentSummary } from "./utils/paymentSummary";
import { PaymentTaxBreakdown } from "./components/PaymentTaxBreakdown";
import {isBuyerPriceEditLocked} from "./utils/buyerPriceEdit";
import {useSelector} from "react-redux";
import axios from "axios";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Select} from "@material-ui/core";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";
import {Switch} from "@material-ui/core";

export default function OrderSummary({currOrder, setIsOderSummaryClicked, setIsOrderUpdated, isOrderUpdated}) {

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )
    const inititalCategoryTree = {
        branches: 0,
        selectedCategories:[],
        categoryType:"",
        children:[]
    }

    const [order,setOrder] = useState(currOrder)
    const [isCartUpdated,setIsCartUpdated] = useState(false)
    const [categoriesTree,setCategoriesTree] = useState(inititalCategoryTree)
    const [fullCategoryTree,setFullCategoryTree] = useState([])
    const [isCategoriesFetched,setIsCategoriesFetched] = useState(false)
    const [locations,setLocations] = useState(order.location)
    const [open, setOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [cancelOpen, setCancelOpen] = useState(false);
    const [cancelDialogMessage, setCancelDialogMessage] = useState("");
    const formRef = useRef();
    const [isDateTodayFuture, setIsDateTodayFuture] = useState(false)
    const [onlinePaymentEnabled, setOnlinePaymentEnabled] = useState(false)

    useEffect(() => {
        if (!accessToken) return
        fetchTenantPaymentSettings(accessToken)
            .then((res) => setOnlinePaymentEnabled(!!res.data?.onlinePaymentEnabled))
            .catch(() => setOnlinePaymentEnabled(false))
    }, [accessToken])

    useEffect(() => {
        console.log("Fetching order again...");
        getOrderInfo(accessToken,order._id).then(response =>{
            // Get new Item
            console.log("✅ Updated Order from API:", response.data);
            let newOrder = response.data
            
            // Log products from API to verify category data exists
            console.log("📦 Products from API (with categories):", newOrder.products?.map(p => ({
                _id: p._id,
                name: p.name,
                categoryName: p.categoryName,
                categoryId: p.categoryId,
                hasCategoryInfo: !!p.categoryInfo
            })));
            
            let oldProducts = [...order.products]
            let oldProductIds = oldProducts.map(item => item._id)
            let newItem = newOrder.products.filter(item => !oldProductIds.includes(item._id))
            
            // Merge: Update old products with new data (including categories) from API, then add new items
            const updatedOldProducts = oldProducts.map(oldProduct => {
                const updatedProduct = newOrder.products.find(p => p._id === oldProduct._id);
                // If product exists in API response, merge it with old product (preserve local changes but update with API data)
                if (updatedProduct) {
                    return {
                        ...oldProduct,
                        ...updatedProduct, // This includes categoryName and categoryInfo from API
                        // Preserve local state if needed (amount, price changes, etc.)
                        amount: oldProduct.amount !== undefined ? oldProduct.amount : updatedProduct.amount,
                        price: oldProduct.price !== undefined ? oldProduct.price : updatedProduct.price,
                        listPrice: oldProduct.listPrice !== undefined ? oldProduct.listPrice : updatedProduct.listPrice,
                    };
                }
                return oldProduct;
            });
            
            // Add new items that don't exist in old products
            if(newItem.length > 0){
                updatedOldProducts.push(...newItem)
            }
            
            // Use the merged products which now include category data
            newOrder.products = updatedOldProducts
            
            // Log final products to verify categories are present
            console.log("📦 Final merged products (should have categories):", newOrder.products?.map(p => ({
                _id: p._id,
                name: p.name,
                categoryName: p.categoryName,
                categoryId: p.categoryId,
                hasCategoryInfo: !!p.categoryInfo
            })));

            console.log("Order: ", newOrder)
            
            setOrder(newOrder)
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isCartUpdated])

    const isDateInFuture = function(firstDate, secondDate) {
        if (firstDate.setHours(0, 0, 0, 0) >= secondDate.setHours(0, 0, 0, 0)) {
          return true;
        }
      
        return false;
      };

    useEffect(() =>{

        if(order.status !== 'Not Submitted'){
            var invoiceDate = new Date(order.invoiceDate.replace(/-/g, '\/'));
            var today = new Date();

            setIsDateTodayFuture(isDateInFuture(invoiceDate, today))
        }

        fetchCategories(order.supplier[0]._id,accessToken).then(response =>{
            // setObjectsArray(response.data)
            setFullCategoryTree(response.data)
            // Initialize selectedCategories as empty array (like SupplierInfo does)
            // This ensures filterCategory will be an empty object when passed to ProductsList
            setCategoriesTree({
                branches: 0,
                selectedCategories: [],
                categoryType: response.data.type,
                children:response.data
            })
            // setDefaultCategory(response.data.type)
            setIsCategoriesFetched(true)
        });

    },[])

    // Helper function to check if an order can be edited (includes special cases)
    const canEditOrder = (order) => {
        // Standard case: Not Submitted orders can always be edited
        if (order.status === "Not Submitted") {
            return true;
        }
        
        // Special case 1: Received orders with future invoice dates
        if (isDateTodayFuture && order.status === "Received") {
            return true;
        }
        
        // Special case 2: WAHMEY tenant with specific route statuses
        if (user.tenant === process.env.REACT_APP_WAHMEY_TENANT) {
            if (order.routeStatus && 
                order.routeStatus !== 'Routing' && 
                order.routeStatus !== 'Completed' && 
                order.routeStatus !== 'Sent to WMS') {
                return true;
            }
        }
        
        return false;
    };

    const handleProductAmountChange = (productId, productAmount) => {
        let currOrder = {...order}

        let products = [...currOrder.products]
        let productIndex = products.findIndex(product => product._id === productId)

        products[productIndex] = {
            ...products[productIndex],
            amount : productAmount,
        }

        const newOrder = {
            ...currOrder,
            products : products
        }
        
        setOrder(newOrder)
    }

    // Helper function to get the appropriate price field based on user role
    const getProductPrice = (product) => {
        if(user.roles.includes("buyer_external")) {
            return product.fob || 0;
        }
        return (product.listPrice || product.listPrice == '') ? product.listPrice : product.price;
    }

    const EA_UOM_SENTINEL = { name: "EA", conversionFactor: 1 };

    const getDisplayUnitOfMeasurement = (product) => {
        const isUsableUom = (u) =>
            u && typeof u === "object" && (u.uomId != null || u.name != null || u.conversionFactor != null);

        if (isUsableUom(product.selectedUnit)) {
            const u = product.selectedUnit;
            return {
                name: u.name ?? EA_UOM_SENTINEL.name,
                conversionFactor: u.conversionFactor ?? EA_UOM_SENTINEL.conversionFactor,
                uomId: u.uomId,
            };
        }
        if (isUsableUom(product.defaultUnitOfMeasurement)) {
            const u = product.defaultUnitOfMeasurement;
            return {
                name: u.name ?? EA_UOM_SENTINEL.name,
                conversionFactor: u.conversionFactor ?? EA_UOM_SENTINEL.conversionFactor,
                uomId: u.uomId,
            };
        }
        const firstUom = (product.unitsOfMeasurement ?? []).filter(Boolean)[0];
        if (firstUom) {
            return {
                name: firstUom.name ?? EA_UOM_SENTINEL.name,
                conversionFactor: firstUom.conversionFactor ?? EA_UOM_SENTINEL.conversionFactor,
                uomId: firstUom.uomId,
            };
        }
        return { name: EA_UOM_SENTINEL.name, conversionFactor: EA_UOM_SENTINEL.conversionFactor, uomId: undefined };
    };

    // Helper function to set the appropriate price field based on user role
    const setProductPrice = (product, newPrice) => {
        if(user.roles.includes("buyer_external")) {
            return {
                ...product,
                fob: newPrice
            };
        }
        if(product.listPrice || product.listPrice == ''){
            return {
                ...product,
                listPrice: newPrice
            };
        }
        return {
            ...product,
            price: newPrice
        };
    }

    const handlePriceChange = (productId, newPrice) => {
        let currOrder = {...order}

        let products = currOrder.products

        let productIndex = products.findIndex(product => product._id === productId)
        const product = products[productIndex]

        let newPriceParsed = parseFloat(newPrice)

        const oldPrice = getProductPrice(product)
        const oldTotalCost = currOrder.totalCost
        const conversionFactor = getDisplayUnitOfMeasurement(product).conversionFactor

        let newTotalCost = parseFloat(oldTotalCost)
        
        if(oldPrice == '' || oldPrice == 0){
            newTotalCost -= parseFloat(product.amount * 0)
        } else{
            if(product.isCatchWeight){
                // newTotalCost -= parseFloat(product.amount * oldEstimatedPrice)
            } else{
                newTotalCost -= parseFloat(product.amount * conversionFactor * oldPrice)
            }
        }   

        if(!isNaN(newPriceParsed)){
            if(product.isCatchWeight){
                // newTotalCost += parseFloat(product.amount * newEstimatedPrice)
            } else{
                newTotalCost += parseFloat(product.amount * conversionFactor * newPriceParsed)
            }
            
        }  

        if(isNaN(newPriceParsed)){
            newPriceParsed = ""
        }

        products[productIndex] = setProductPrice(product, newPriceParsed)
        if(product.isCatchWeight){
            // products[productIndex].estimatedPrice = newEstimatedPrice
        }

        const newOrder = {
            ...currOrder,
            totalCost : newTotalCost,
            products : products
        }

        setOrder(newOrder)
    }

    const handleProductUnitChange = (productId, selectedUnitId) => {
        let currOrder = {...order}
        let products = currOrder.products
        let productIndex = products.findIndex(product => product._id === productId)
        const product = products[productIndex]

        const productAmount = product.amount;
        const productPrice = getProductPrice(product)
        const oldTotalCost = currOrder.totalCost
        let newTotalCost = parseFloat(oldTotalCost)

        const oldConversionFactor = getDisplayUnitOfMeasurement(product).conversionFactor
        const newSelectedUnitObject = (product.unitsOfMeasurement ?? [])
            .filter(Boolean)
            .find(uom => uom.uomId == selectedUnitId)

        if (!newSelectedUnitObject) {
            return
        }

        const newConversionFactor = newSelectedUnitObject.conversionFactor

        if(productPrice > 0){
            newTotalCost -= parseFloat(productPrice) * productAmount * oldConversionFactor
            newTotalCost += parseFloat(productPrice) * productAmount * newConversionFactor
        }

        products[productIndex] = {
            ...products[productIndex],
            selectedUnit: newSelectedUnitObject
        }

        const newOrder = {
            ...currOrder,
            totalCost : newTotalCost,
            products : products
        }

        setOrder(newOrder)
    }

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose(isRefresh = false) {
        setOpen(false);
        if(isRefresh){
            window.location.reload()
        }
    }

    function handleCancelClose() {
        setCancelOpen(false);
        
    }

    function handleRemove(productId) {
        let currOrder = {...order}

        let products = currOrder.products.filter(product => product._id !== productId)

        const newOrder = {
            ...currOrder,
            products : products
        }
        
        setOrder(newOrder)
    }

    function handleBack() {
        
        setIsOderSummaryClicked(false)
    }
  
    function handleBackOrderConversion() {
        
        const orderUpdate = {
            orderId: order._id,
            customerPo: order.customerPo,
            comment: order.comment,
            invoiceDate: order.invoiceDate,
            shipDate: order.shipDate,
            products: order.products,
            status: "Not Submitted",

            deliveryPurpose: order.deliveryPurpose,
            expectedDeliveryDate: order.expectedDeliveryDate,
            proofOfDelivery : order.proofOfDelivery,
            allecInvWareHouse : order.allecInvWareHouse,
            contactPerson : order.contactPerson,
            phoneNumber : order.phoneNumber,
        }

        patchOrderSummary(orderUpdate, accessToken).then(response => {
            setIsCartUpdated(!isCartUpdated)
            setDialogMessage("Order has been updated successfully.")
            handleClickOpen()
       }).catch(err => {
            console.log("Error updating order.")
            setDialogMessage("There was an error updating the order. Contact Allec team for further asistance.")
            handleClickOpen()
       })
    }

    function handleOrderCancelationClick() {
        setCancelDialogMessage("Are you sure you want to cancel order? Data may be lost.")
        setCancelOpen(true);
    }

    function handleOrderCancelation() {
        
        const orderUpdate = {
            orderId: order._id,
        }

        cancelOrder(orderUpdate, accessToken).then(response => {
            setDialogMessage("Order has been cancelled successfully.")
            handleClickOpen()
       }).catch(err => {
            console.log("Error cancelling order.")
            setDialogMessage("There was an error canceling the order. Contact Allec team for further asistance.")
            handleClickOpen()
       })
    }

    function toFixedCustom(num, fixed) {
        var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
        return num.toString().match(re)[0];
    }

    // Helper function to check if a product has multiple units of measurement
    const hasMultipleUnits = (product) => {
        return product.unitsOfMeasurement && product.unitsOfMeasurement.length > 1;
    }

    // Helper function to check if any product in an order has multiple units
    const orderHasMultipleUnits = (order) => {
        return order.products.some(product => hasMultipleUnits(product));
    }

    const handlePrintOrder = async () => {
        let totalAmount = 0
        const salesOrderProductsData = order.products.map(currItem => {
            let itemPrice = getProductPrice(currItem)
            let itemTotalAmount = 0
            const displayUom = getDisplayUnitOfMeasurement(currItem)

            itemTotalAmount = (itemPrice * currItem.amount)
            totalAmount += itemPrice * currItem.amount

            return {
                itemNumber: currItem.itemNumber,
                upc: currItem.sku,
                name: currItem.name,
                description: currItem.description,
                category: currItem.categoryName,
                units: currItem.amount,
                selectedUnit: displayUom.name,
                conversionFactor: displayUom.conversionFactor,
                itemPrice: itemPrice,
                totalAmount: itemTotalAmount.toFixed(2),
            }
        })

        const location = order.location[0]

        const salesOrderData = {
            orderNumber: order.quoteNumber ? order.quoteNumber : order.orderNumber,
            invoiceDate: order.invoiceDate ? order.invoiceDate :order.submissionDate,

            customerName: location.locationName,
            customerAddressLine1: location.locationAddress1,
            customerAddressLine2: location.locationAddress2,
            customerCity: location.locationCity,
            customerZip: location.locationZipcode,

            customerId: order.company[0].sageCustomerId,
            paymentTerms: order.company[0].dueDays ? order.company[0].dueDays : 0,
            salesRep: order.user[0].fullName,

            products: salesOrderProductsData,
            totalAmount: totalAmount.toFixed(2),
            comment: order.comment,

            logoPath: order.supplier[0].logoPath,
        }
        
        console.log("Sales Order Data: ", salesOrderData)

        const urlPath = process.env.REACT_APP_WMS_API_HTTPS + (process.env.REACT_APP_ENV === 'DEV' ?
            `${process.env.REACT_APP_WMS_API_URL}/tenants/${order.supplier[0].tenantId}/bw_quote_pdf` :
            `${order.supplier[0].tenantId}.${process.env.REACT_APP_WMS_API_URL}/tenants/${order.supplier[0].tenantId}/bw_quote_pdf`
          );

        const response = await axios.post(urlPath, 
        salesOrderData, {
            responseType: 'arraybuffer', // Ensure the response type is set to arraybuffer
        });

        // Create a Blob from the PDF data
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open a new tab with the PDF
        const newTab = window.open(pdfUrl, '_blank');
    }

    return(
        <>
            <button type="button" className="btn btn-primary mb-6" onClick={() => handleBack()} >Back</button>
            <Card>
                <CardHeader title={`Order #${order?.orderNumber} | ${order?.companyName}`}>

                </CardHeader>
                <CardBody>
                    <table className="table table-head-custom table-head-bg table-borderless table-vertical-center table-padding">
                        <thead>
                            <tr> 
                                <th>Product</th>
                                <th>SKU</th>
                                <th>Unit Price</th>
                                <th>Product Qty.</th>
                                <th>UoM</th>
                                <th>Total Amount</th>
                                { canEditOrder(order) ?
                                    <th>Remove</th>
                                    :
                                    null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {order?.products?.map((product,index) =>  {
                                const displayUom = getDisplayUnitOfMeasurement(product);
                                return (
                                <tr>
                                    <td className="border-top-0 pl-0">
                                        { product.imagePath ? 
                                            <div className="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                <div className="symbol-label"
                                                    style={{backgroundImage: "url(" + product.imagePath + ")"}}></div>
                                            </div>
                                            :
                                            null
                                        }
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {product.description ? product.description : product.name}
                                        </span>
                                    </td>
                                    <td>
                                        {product.itemNumber && (
                                            <span className="text-dark font-weight-bolder text-hover-primary font-size-lg d-block">
                                                {product.itemNumber}
                                            </span>
                                        )}
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {product.sku}
                                        </span>
                                    </td>
                                    <td className="border-top-0 text-right py-2 align-middle">
                                        {user.tenant === process.env.REACT_APP_PEPEGANGA_TENANT || isBuyerPriceEditLocked(order.supplier && order.supplier[0]) ? (
                                            <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                ${getProductPrice(product)}
                                            </span>
                                        ) : (
                                            <NumberInput
                                                value={getProductPrice(product)}
                                                onChange={(e) => handlePriceChange(product._id, e.target.value)}
                                                className={`form-control form-control-solid h-auto py-2 px-6`}
                                                min="0"
                                            />
                                        )}
                                        {/* Only show FOB for regular users if supplier.isExternal is NOT false */}
                                        {!user.roles.includes("buyer_external") && product.fob && order.supplier && order.supplier[0] && order.supplier[0].isExternal !== false && (
                                            <div className="text-muted font-size-sm mt-1">
                                                FOB: ${product.fob}
                                            </div>
                                        )}
                                        {/* Show discount price for regular users when supplier is not external */}
                                        {!user.roles.includes("buyer_external") && order.supplier && order.supplier[0] && order.supplier[0].isExternal === false && product.discountPrice && (
                                            <div className="text-muted font-size-sm mt-1">
                                                Discount Price: ${product.discountPrice}
                                            </div>
                                        )}
                                    </td>
                                    <td className="border-top-0 text-center py-2 align-items-center" style={{minWidth:"125px"}}>
                                        { canEditOrder(order) ?
                                            <div className="align-middle">
                                                <button className="btn btn-xs btn-light-primary btn-icon mr-2" disabled={product.amount === 0} onClick={() => {
                                                    handleProductAmountChange(product._id, product.amount - 1)
                                                }}>
                                                    <i className="ki ki-minus icon-xs"></i>
                                                </button>
                                                <span className="mr-2 font-weight-bolder align-middle">{product.amount}</span>
                                                <button className="btn btn-xs btn-light-primary btn-icon mr-2" onClick={() => {
                                                    handleProductAmountChange(product._id, product.amount + 1)
                                                }} >
                                                    <i className="ki ki-plus icon-xs"></i>
                                                </button>
                                            </div>
                                            :
                                            <span className="mr-2 font-weight-bolder align-middle">{product.amount}</span>
                                        }
                                    </td>
                                    <td className="border-top-0 text-center py-2 align-middle">
                                        {hasMultipleUnits(product) ? (
                                            <div className="form-group fv-plugins-icon-container align-middle">
                                                <Select
                                                    value={displayUom.uomId ?? ''}
                                                    onChange={(e) => handleProductUnitChange(product._id, e.target.value)}
                                                    input={
                                                        <FilledInput
                                                        name={`product-${displayUom.uomId ?? index}`}
                                                        id={`product-${displayUom.uomId ?? index}`}
                                                        className="form-control form-control-solid h-2 py-2 px-6 align-middle"
                                                        />
                                                    }
                                                    >
                                                    {(product.unitsOfMeasurement ?? []).filter(Boolean).map((uom, uomIdx) => (
                                                        <MenuItem key={uom.uomId ?? `uom-${uomIdx}`} value={uom.uomId}>
                                                            {`${uom.name ?? EA_UOM_SENTINEL.name} (${uom.conversionFactor ?? EA_UOM_SENTINEL.conversionFactor})`}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                        ) : (
                                            <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                {`${displayUom.name} (${displayUom.conversionFactor})`}
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                            <span className="label label-lg label-light-primary label-inline">
                                                ${toFixedCustom((getProductPrice(product) * product.amount * displayUom.conversionFactor), 2)}
                                            </span>
                                        </span>
                                    </td>
                                    { canEditOrder(order) ?
                                        <td>
                                            <InputAdornment position="end">
                                                <IconButton  onClick={() => handleRemove(product._id)}
                                                >
                                                <span  className="center svg-icon svg-icon-md svg-icon-primary">
                                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                </span>
                                                </IconButton>
                                            </InputAdornment>
                                        </td>
                                        :
                                        null
                                    }
                                </tr>
                            );})}
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            { canEditOrder(order) ?
                    isCategoriesFetched  ? 
                        <Card>
                            <CardHeader title={`Order #${order?.orderNumber} | ${order?.companyName}`}>

                            </CardHeader>
                            <CardBody>
                                <div className="row">
                                    <p>{order.supplier[0].description}</p>
                                </div>
                            </CardBody>

                            <ProductsList filterCategory={categoriesTree.selectedCategories.length > 0 ? categoriesTree.selectedCategories[categoriesTree.selectedCategories.length - 1] : {}} supplier={order.supplier[0]} 
                                        categories={fullCategoryTree} company={order.company[0]} locations={locations}
                                        isOrderSummary={true} setIsCartUpdated={setIsCartUpdated} isCartUpdated={isCartUpdated} 
                                        orderId={order._id} order={order} user={user}/>
                        </Card>
                    
                    :
                        <div className="row justify-content-center">
                            <span className="spinner spinner-primary spinner-lg"></span>
                        </div>
                :
                null
            }
            <Card>
                
                <CardHeader title={`Order #${order?.orderNumber} Details`}>
                    
                </CardHeader>
                <CardBody>
                    <Formik
                        initialValues={order}
                        innerRef={formRef}
                        enableReinitialize={true}
                        onSubmit={(values)=>{
                            console.log('Submit bro!?');
                            console.log("Sending to API:", values);
                            const orderUpdate = {
                                orderId: values._id,
                                customerPo: values.customerPo,
                                comment: values.comment,
                                invoiceDate: values.invoiceDate,
                                shipDate: values.shipDate,
                                products: order.products,
                                status: values.status,

                                deliveryPurpose: values.deliveryPurpose,
                                expectedDeliveryDate: values.expectedDeliveryDate,
                                proofOfDelivery : values.proofOfDelivery,
                                allecInvWareHouse : values.allecInvWareHouse,
                                contactPerson : values.contactPerson,
                                phoneNumber : values.phoneNumber,

                            }

                            console.log(orderUpdate);

                            patchOrderSummary(orderUpdate, accessToken).then(response => {
                                setIsCartUpdated(!isCartUpdated)
                                setIsOrderUpdated(!isOrderUpdated)
                                setDialogMessage("Order has been updated successfully.")
                                handleClickOpen()
                            }).catch(err => {
                                console.log("Error updating order.")
                                setDialogMessage("There was an error updating order. Contact Allec team for further asistance.")
                                handleClickOpen()
                            })
                        }}
                    >
                        {(props) => (
                            <Form>
                                <div>
                                    <div className="row align-self-center">
                                        <div className="col-md-6">
                                            <MyTextInput
                                                label="Company"
                                                name="companyName"
                                                type="text"
                                                placeholder=""
                                                value={order?.companyName}
                                                disabled
                                            />
                                            <MyTextInput
                                                label="Location"
                                                name="locationAddressCity"
                                                type="text"
                                                placeholder=""
                                                value={order?.locationAddressCity}
                                                disabled
                                            />
                                            <MyTextInput
                                                label="Supplier"
                                                name="supplierName"
                                                type="text"
                                                placeholder=""
                                                value={order?.supplierName}
                                                disabled
                                            />
                                            <MyTextInput
                                                label="Total Product"
                                                name="totalProductQty"
                                                type="number"
                                                placeholder="###"
                                                value={order?.totalProductQty}
                                                disabled
                                            />
                                            <MyTextInput
                                                label="Total Cost"
                                                name="totalCost"
                                                type="text"
                                                placeholder="$##.##"
                                                value={order?.totalCost ? `$${order?.totalCost}` : order?.totalCost}
                                                disabled
                                            />
                                            {onlinePaymentEnabled && getPaymentSummary(order) ? (
                                                <div className="mt-3">
                                                    <PaymentTaxBreakdown summary={getPaymentSummary(order)} className="text-left" />
                                                </div>
                                            ) : null}
                                            <MyTextInput
                                                label="Status"
                                                name="status"
                                                type="text"
                                                placeholder="###"
                                                value={order?.status}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <MyTextInput
                                                label="Customer PO"
                                                name="customerPo"
                                                type="text"
                                                placeholder=""
                                                value={props.values.customerPo}
                                            />

                                            {process.env.REACT_APP_MCS_TENANT === user.tenant ?
                                                (
                                                    <MyTextInput
                                                        label="Special Instructions"
                                                        name="comment"
                                                        type="text"
                                                        placeholder="Special Instructions"
                                                        value={props.values.comment}
                                                    />
                                                ) : (
                                                    <MyTextInput
                                                        label="Comment"
                                                        name="comment"
                                                        type="text"
                                                        placeholder="###"
                                                        value={props.values.comment}
                                                    />
                                                )
                                            }
                                            { canEditOrder(order) ?
                                                null
                                                :
                                                <MyTextInput
                                                    label="Ship via"
                                                    name="shipVia"
                                                    type="text"
                                                    placeholder="###"
                                                    value={order?.shipVia}
                                                    disabled
                                                />
                                            }
                                            <div className="form-group fv-plugins-icon-container">
                                                <label htmlFor={"invoiceDate"}>Invoice Date</label>
                                                <Input
                                                    type="date"
                                                    className={`form-control form-control-solid h-auto py-5 px-6`}
                                                    name="invoiceDate"
                                                    onChange={props.handleChange}
                                                    value={props.values.invoiceDate}
                                                />
                                            </div>
                                            <div className="form-group fv-plugins-icon-container">
                                                <label htmlFor={"shipDate"}>Ship Date</label>
                                                <Input
                                                    type="date"
                                                    className={`form-control form-control-solid h-auto py-5 px-6`}
                                                    name="shipDate"
                                                    onChange={props.handleChange}
                                                    value={props.values.shipDate}
                                                />
                                            </div>
                                            {process.env.REACT_APP_MCS_TENANT === user.tenant ?
                                                (
                                                    <div>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <label htmlFor={"expectedDeliveryDate"}>Expected Delivery
                                                                Date</label>
                                                            <Input
                                                                type="date"
                                                                className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                name="expectedDeliveryDate"
                                                                onChange={props.handleChange}
                                                                value={props.values.expectedDeliveryDate}
                                                            />
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <FormControl variant="filled" style={{width: "100%"}}>
                                                                <InputLabel>Ship To</InputLabel>
                                                                <Select
                                                                    MenuProps={{autoFocus: false}}
                                                                    value={props.values.allecInvWareHouse}
                                                                    style={{minWidth: "200px"}}
                                                                    onChange={props.handleChange}
                                                                    input={
                                                                        <FilledInput
                                                                            name="allecInvWareHouse"
                                                                            id="allecInvWareHouse"
                                                                            type="text"
                                                                            className="form-control form-control-solid h-auto"
                                                                        />
                                                                    }
                                                                >
                                                                    {
                                                                        order.supplier[0].warehouses?.map((warehouse) => (
                                                                            <MenuItem
                                                                                key={warehouse.id}
                                                                                value={warehouse.id}
                                                                            >
                                                                                {warehouse.name}
                                                                            </MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </div>
                                                        {/*-------*/}
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <MyTextInput
                                                                label="Delivery Purpose"
                                                                name="deliveryPurpose"
                                                                type="text"
                                                                placeholder="Delivery Purpose"
                                                                onChange={props.handleChange}
                                                                value={props.values.deliveryPurpose}
                                                            />
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <MyTextInput
                                                                label="Contact Person"
                                                                name="contactPerson"
                                                                type="text"
                                                                placeholder="Contact Person"
                                                                onChange={props.handleChange}
                                                                value={props.values.contactPerson}
                                                            />
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <MyTextInput
                                                                label="Phone Number"
                                                                name="phoneNumber"
                                                                type="text"
                                                                placeholder="Phone Number"
                                                                onChange={props.handleChange}
                                                                value={props.values.phoneNumber}
                                                            />
                                                        </div>
                                                        {/*-------*/}
                                                        <div>
                                                            <label htmlFor={"proofOfDeliveryToggle"}>Proof of
                                                                Delivery</label>
                                                            {/*<Switch*/}
                                                            {/*    checked={props.values.proofOfDelivery}*/}
                                                            {/*    onChange={props.handleChange}*/}
                                                            {/*    name="proofOfDeliveryToggle"*/}
                                                            {/*    color="primary"*/}
                                                            {/*/>*/}

                                                            <Switch
                                                                checked={props.values.proofOfDelivery}
                                                                onChange={(e) => props.setFieldValue("proofOfDelivery", e.target.checked)}
                                                                name="proofOfDelivery"
                                                                color="primary"
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}

                                            {(typeof (props.values.submissionDate) !== 'undefined' && props.values.submissionDate !== '') ?
                                                <div className="form-group fv-plugins-icon-container">
                                                    <label htmlFor={"submissionDate"}>Submission Date</label>
                                                    <Input
                                                        type="date"
                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                        name="submissionDate"
                                                        onChange={props.handleChange}
                                                        disabled
                                                        value={props.values.submissionDate}
                                                    />
                                                </div>
                                                :
                                                null
                                            }
                                            {typeof (props.values.processedDate) !== 'undefined' ?
                                                <div className="form-group fv-plugins-icon-container">
                                                    <label htmlFor={"processedDate"}>Processed Date</label>
                                                    <Input
                                                        type="date"
                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                        name="processedDate"
                                                        onChange={props.handleChange}
                                                        disabled
                                                        value={props.values.processedDate}
                                                    />
                                                </div>
                                                :
                                                null
                                            }
                                            {typeof (props.values.inTransitDate) !== 'undefined' ?
                                                <div className="form-group fv-plugins-icon-container">
                                                    <label htmlFor={"inTransitDate"}>In Transit Date</label>
                                                    <Input
                                                        type="date"
                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                        name="inTransitDate"
                                                        onChange={props.handleChange}
                                                        disabled
                                                        value={props.values.inTransitDate}
                                                    />
                                                </div>
                                                :
                                                null
                                            }
                                            {typeof(props.values.deliveredDate) !== 'undefined' ?
                                                <div className="form-group fv-plugins-icon-container">
                                                    <label htmlFor={"deliveredDate"}>Delivered Date</label>
                                                    <Input
                                                        type="date"
                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                        name="deliveredDate"
                                                        onChange={props.handleChange}
                                                        disabled
                                                        value={props.values.deliveredDate}
                                                    />
                                                </div>
                                                :
                                                null
                                            }
                                        </div>

                                    </div>
                                </div>
                                <div className="row col-12 justify-content-center">
                                    <div className="row col-6">
                                        <button type="button" className="btn btn-primary" onClick={() => handleOrderCancelationClick()} >Cancel Order</button>
                                        {(order.status === "Quote" || order.status === "Quote Received") && (
                                            <button 
                                                type="button" 
                                                className="btn btn-light-primary font-weight-bold ml-3" 
                                                onClick={() => handlePrintOrder()}
                                            >
                                                Print Quote
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-6 justify-content-end d-flex">
                                        {/* { (order.status == "Not Submitted" || (isDateTodayFuture && order.status == "Received")  || ((order.routeStatus != "Routing" && order.routeStatus !="Completed" && order.routeStatus !="Sent to WMS") && user.tenant == process.env.REACT_APP_WAHMEY_TENANT)) ?
                                            
                                            <button type="submit" className="btn btn-primary" >Update Order</button>
                                            
                                            :
                                            null
                                        } */}
                                        { canEditOrder(order) ?
                                            
                                            <button type="submit" className="btn btn-primary" >Update Order</button>
                                            
                                            :
                                            null
                                        }
                                        { (order.status == "Back Order") ?
                                            <button type="button" className="btn btn-primary" onClick={() => handleBackOrderConversion()} >Convert to Order</button>
                                            
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </Form>
                        )}
                        
                    </Formik>
                </CardBody>
            </Card>

            <Card>
                <CardHeader title={`Order Updates`}>

                </CardHeader>
                <CardBody>
                    <table className="table table-head-custom table-head-bg table-borderless table-vertical-center table-padding">
                        <thead>
                            <tr> 
                                <th>Action</th>
                                <th>Product</th>
                                <th>SKU</th>
                                <th>Previous Price</th>
                                <th>New Price</th>
                                <th>Previous Qty.</th>
                                <th>New Qty.</th>
                                <th>Updated By</th>
                                <th>Update Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order?.itemUpdates?.map((update, idx) =>  (
                                <tr key={`item-update-${idx}`}>
                                    <td className="border-top-0 pl-0">
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {update.operation}
                                        </span>
                                    </td>
                                    <td className="border-top-0 pl-0">
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            Product Name
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {update.sku}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {   update.operation == 'Updated' ?
                                                    update.previousPrice.toFixed(2)
                                                :
                                                update.operation == 'Added' ?
                                                    "N / A"
                                                :
                                                    update.price
                                            }
                                        </span>
                                    </td>
                                    <td className="border-top-0 text-right py-2 align-middle">
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {   update.operation == 'Updated' || update.operation == 'Added' ?
                                                    update.newPrice.toFixed(2)
                                                :
                                                    "N / A"
                                            }
                                        </span>
                                    </td>
                                    <td className="border-top-0 text-center py-2 align-items-center" style={{minWidth:"125px"}}>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {   update.operation == 'Updated' ?
                                                    update.previousQuantity
                                                :
                                                update.operation == 'Added' ?
                                                    "N / A"
                                                :
                                                    update.quantity
                                            }
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {   update.operation == 'Updated' || update.operation == 'Added' ?
                                                    update.newQuantity
                                                :
                                                    "N / A"
                                            }
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {update.updatedByUserEmailAtChange || '—'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            { 
                                                new Date(update.updatedAt).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                })
                                            
                                            }
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            
            {/* <ProductEditModal
                product={editProduct}
                setProduct={setEditProduct}
                showModal={showProductModal}
                setShowModal={setShowProductModal}
                locations={locations}
                order={order}
                setOrder={setOrder}
            /> */}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Order Confirmation"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {dialogMessage}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => handleClose(true)} color="primary" autoFocus>
                    OK
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={cancelOpen}
                onClose={handleCancelClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Order Confirmation"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {cancelDialogMessage}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancelClose} color="primary" autoFocus>
                    No
                </Button>
                <Button onClick={handleOrderCancelation} color="primary" autoFocus>
                    Yes
                </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}